/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { periods } from '../../constants';
import { optionsPie } from '../../constants/defaultOptionsChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { transformDataToPie } from '../../utils/chartHelper';
import Loading from '../Loading';

const PieChart = ({
  data,
  categories,
  loading,
  dateRange,
  chartTitle = '',
  chartSubtitle = '',
  categoriesOrder = []
}) => {
  const [activePeriod, setActivePeriod] = useState(periods.DAY);
  const [options, setOptions] = useState({
    ...optionsPie
  });

  const drawChart = () => {
    const optionsTemp = transformDataToPie(data, categories, options);

    if (optionsTemp?.series?.[0]?.data && categoriesOrder.length > 0) {
      optionsTemp.series[0].data = optionsTemp?.series?.[0]?.data.sort(
        (a, b) => {
          const indexA = categoriesOrder.indexOf(a.id);
          const indexB = categoriesOrder.indexOf(b.id);

          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;

          return indexA - indexB;
        }
      );

      optionsTemp.series[0].data = optionsTemp.series[0].data.map(
        (serie, key) => {
          return { ...serie, color: options.colors[key] };
        }
      );
    }

    setOptions({ ...options, ...optionsTemp });
  };

  const handleChangeTime = perTemp => {
    setActivePeriod(perTemp);
  };

  useEffect(() => {
    if (!data && options.series.length > 0) {
      setOptions({ ...options, series: [] });
    } else if (data) {
      drawChart();
    }
  }, [activePeriod, data, categoriesOrder]);

  return (
    <div className="col-span-12 min-w-0 overflow-hidden rounded-sm border border-stroke bg-white px-4 pb-5 pt-6 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-6 sm:pt-7.5 xl:col-span-6 xl:px-7.5">
      {loading ? (
        <Loading type="pie" />
      ) : (
        <>
          <div className="flex flex-col gap-3">
            <div className="flex w-full flex-wrap gap-3 sm:gap-5">
              <div className="flex w-full min-w-0">
                <span className="mt-1 mr-2 flex h-4 w-full max-w-4 items-center justify-center rounded-full border border-primary">
                  <span className="block h-2.5 w-full max-w-2.5 rounded-full bg-primary"></span>
                </span>
                <div className="w-full">
                  <p className="break-words font-semibold text-primary">
                    {chartTitle}
                  </p>
                  <p className="text-xs font-medium text-slate-500 dark:text-slate-400">
                    {dateRange?.startDate} - {dateRange?.endDate}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 min-w-0 sm:mt-8">
            <div className="w-full min-w-0 max-w-full overflow-hidden">
              <HighchartsReact
                containerProps={{ className: 'dashboard-chart-host' }}
                highcharts={Highcharts}
                options={{ ...options }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PieChart;
